var icon = require('vue-svgicon')
icon.register({
  'ks-icon-cc': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M100.8 45.6H27.2v-9.2h73.6m0 55.2H27.2V64h73.6m0-36.8H27.2a9.17 9.17 0 0 0-9.2 9.2v55.2a9.2 9.2 0 0 0 9.2 9.2h73.6a9.2 9.2 0 0 0 9.2-9.2V36.4a9.2 9.2 0 0 0-9.2-9.2z"/>'
  }
})
